import { fetchAPI } from '@/shared/lib/api/client';
import type { CurrencyCode } from '@/shared/lib/currency';

import { MinesActiveGame } from '../model/types';

export interface MinesClickResponse {
  isMine: boolean;
  cellIndex: number;
  revealedPositions: number[];
  currentMultiplier?: number;
  nextMultiplier?: number | null;
  minePositions?: number[];
  serverSeed?: string;
  payout?: number;
  radarHint?: number | null;
}

export interface MinesCashoutResponse {
  payout: number;
  multiplier: number;
  minePositions: number[];
  serverSeed: string;
  clientSeed: string;
  nonce: number;
}

export const minesApi = {
  async getActive(): Promise<MinesActiveGame | null> {
    const { data } = await fetchAPI.get<MinesActiveGame | null>('/mines/active');
    return data;
  },

  async start(
    betAmount: number,
    minesCount: number,
    clientSeed: string,
    currency: CurrencyCode,
    giftId?: string,
  ): Promise<MinesActiveGame> {
    const { data } = await fetchAPI.post<MinesActiveGame>('/mines/start', {
      betAmount,
      minesCount,
      clientSeed,
      currency,
      giftId,
    });
    return data;
  },

  async click(cellIndex: number): Promise<MinesClickResponse> {
    const { data } = await fetchAPI.post<MinesClickResponse>('/mines/click', { cellIndex });
    return data;
  },

  async cashout(): Promise<MinesCashoutResponse> {
    const { data } = await fetchAPI.post<MinesCashoutResponse>('/mines/cashout');
    return data;
  },
};
